export const appBaseURL = "/"

export const appCdnURL = "https://rdgta.cdn.cyagen.com/rddc-resources/47fb60d5"

export const appHead = {"meta":[{"charset":"utf-8"},{"name":"renderer","content":"webkit"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"baidu-site-verification","content":"codeva-jPwtSliwCe"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"}],"style":[],"script":[{"src":"https://rdgta.cdn.cyagen.com/rdgt/file/client.js","type":"text/javascript"},{"src":"https://rdgta.cdn.cyagen.com/rdgt/file/systemjs.js","type":"text/javascript"}],"noscript":[],"title":"RDDC 罕见病数据库","htmlAttrs":{"lang":"zh"}}

export const appBuildAssetsDir = "/_nuxt/"

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"prefetch":true,"prefetchOn":{"visibility":false,"interaction":true},"componentName":"NuxtLink"}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false